import { IWorkflowStateThresholdData } from '@/models/workflow';

export const mockWorkflowStateThresholdsData: IWorkflowStateThresholdData[] = [
  {
    id: 1,
    group: 1,
    threshold: 100
  },
  {
    id: 2,
    group: 1,
    threshold: 1000
  }
];
